"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROJECT_TYPE = void 0;
var PROJECT_TYPE = {
  VIDEO: 'VIDEO',
  // for PRO
  PODCAST: 'PODCAST',
  // for PRO
  ANIMATION: 'ANIMATION',
  // for PRO
  WEBINAR: 'WEBINAR',
  // for PRO
  PROMO: 'PROMO',
  // for PITCH (elevate)
  SCRIPTLESS: 'SCRIPTLESS',
  // for PITCH (elevate)
  BLANK: 'BLANK' // for PITCH (elevate)

};
exports.PROJECT_TYPE = PROJECT_TYPE;